<mat-form-field
	[color]="color"
	[appearance]="matAppearance"
	[hideRequiredMarker]="defaultOptions?.hideRequiredMarker"
	[floatLabel]="$$floatLabel"
>
	<mat-label>{{ label | bpTranslate | async }}</mat-label>
	<input
		matInput
		[attr.name]="name"
		[matDatepicker]="picker"
		[formControl]="internalControl"
		[placeholder]="$any(placeholder | bpTranslate | async)"
		[required]="!!required"
		[min]="min"
		[max]="max"
		(click)="picker.open()"
		(dateChange)="set($event.value)"
	/>

	<mat-error [bpFieldError]="name" [bpFieldErrorSuppress]="hideErrorText"> </mat-error>

	<mat-hint *ngIf="hint">
		{{ hint | bpTranslate | async }}
	</mat-hint>

	<div class="clear-button-wrapper">
		<div [class.show]="!!internalControl.value">
			<button
				type="button"
				mat-icon-button
				[disabled]="internalControl.disabled"
				(click)="$$eraseInternalControlValue()"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</mat-form-field>

<mat-datepicker
	#picker
	[calendarHeaderComponent]="DatepickerCalendarHeaderComponent"
	[startAt]="startAt"
	[startView]="startView ?? 'month'"
>
</mat-datepicker>
